import { useEffect, useState } from 'react';
import { globalEmitter, emitterProps } from '../helpers/emitter';
import { getOmneoToken } from '../helpers/omneo';
import { OmneoList, omneoListEmpty } from '../types';
import { WishlistDetailContent, WishlistDetailHeader } from './WishlistDetail';
import { WishlistListContent, WishlistListHeader } from './WishlistList';
import { LoaderSpin } from './LoaderSpin';

export function WishlistDashboard () {
  const [isLoading, setIsLoading] = useState(true)
  const [isAccount, setIsAccount] = useState(true)
  const [page, setPage] = useState('list')
  const [lists, setLists] = useState<OmneoList[]>([])
  const [currentList, setCurrentList] = useState<OmneoList>(omneoListEmpty)
  const [changeList, setChangeList] = useState(true)

  const urlParams = new URL(window.location.href)

  const checkAccountToken = async () => {
    const token = await getOmneoToken()
    setIsAccount(!!token)
  }

  const fetchLists = async () => {
    const lists = await window.omneoService.getLists()
    setLists(lists)
  }

  const updateLists = (list: OmneoList) => {
    const _lists = lists.map((item: OmneoList) => {
      if (item.id === list.id) {
        item = list
      }
      return item
    })
    setLists(_lists)
  }

  const deleteList = (list: OmneoList) => {
    const _lists = lists.filter((item: OmneoList) => item.id !== list.id)
    setLists(_lists)
    setPage('list')
  }

  const triggerEvent = () => {
    globalEmitter.on('updateList', (payload) => {
      setCurrentList(payload.list)
      updateLists(payload.list)
    })
    globalEmitter.on('deleteList', (payload) => {
      deleteList(payload.list)
    })
  }

  useEffect(() => {
    globalEmitter.on('createNewList', () => {
      setChangeList(!changeList)
    })
    globalEmitter.on(emitterProps.wishlist.remove, () => {
      setChangeList(!changeList)
    })
  })

  useEffect(() => {
    setTimeout(async () => {
      await checkAccountToken()
      await fetchLists()
      setIsLoading(false)
    }, 500)
  }, []);

  useEffect(() => {
    if (!lists.length) return
    triggerEvent()
    const idListItemByHashUrl = urlParams.hash.replace('#view=detail&id=', '')
    if (idListItemByHashUrl) {
      const listWithHandle = lists.find(list => list.id === parseInt(idListItemByHashUrl))
      if (listWithHandle) {
        setCurrentList(listWithHandle)
        setPage('detail')
      }
    }

    if (window.location.hash === '') {
      window.location.hash = '#view=lists'
    }

    window.addEventListener(
      "hashchange",
      () => {
        const hashUrl = window.location.hash

        if (hashUrl) {
          if (hashUrl.includes('#view=lists')) {
            setPage('list')
          } else if (hashUrl.includes('#view=detail&id=')) {
            const idList = hashUrl.replace('#view=detail&id=', '')
            const listWithHandle = idList && lists.find(list => list.id === parseInt(idList))
            if (listWithHandle) {
              setCurrentList(listWithHandle)
              setPage('detail')
            }
          }
        }
      },
      false,
    );
  }, [lists]);

  useEffect(() => {
    (async () => {
      await fetchLists()
    })()
  }, [changeList]);

  return (
    <div>
      {isLoading ? <div className="relative bg-background-light py-[100px]"><LoaderSpin classSize="w-10 h-10" /></div> :
        <>
          <RenderWishlistHeader lists={lists} page={page} currentList={currentList} setPage={setPage} />
          <div className="relative pb-[60px] overflow-hidden bg-background-light border-0 border-b border-solid border-secondary lg:pb-20">
            {!isLoading && !isAccount && <div>Account not validate</div>}
            {!isLoading && isAccount && <RenderWishlistContent page={page} lists={lists} currentList={currentList} setPage={setPage} setCurrentList={setCurrentList} />}
          </div>
        </>
      }
    </div>
  )
}

type headerProps = {
  lists: OmneoList[]
  page: string
  setPage: React.Dispatch<React.SetStateAction<string>>
  currentList: OmneoList
}

function RenderWishlistHeader ({ lists, page, currentList, setPage }: headerProps) {
  switch (page) {
    case 'detail':
      return <WishlistDetailHeader lists={lists} currentList={currentList} setPage={setPage} />
    default:
      return <WishlistListHeader lists={lists} />
  }
}

type contentProps = {
  page: string
  lists: OmneoList[]
  currentList: OmneoList
  setPage: React.Dispatch<React.SetStateAction<string>>
  setCurrentList: React.Dispatch<React.SetStateAction<OmneoList>>
}

function RenderWishlistContent ({ page, lists, currentList, setPage, setCurrentList }: contentProps) {
  switch (page) {
    case 'detail':
      return <WishlistDetailContent key={currentList.id} currentList={currentList} />
    default:
      return <WishlistListContent lists={lists} setPage={setPage} setCurrentList={setCurrentList} />
  }
}
